import React from 'react';
import { useHistory } from 'react-router-dom';
import { withStyles } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Skeleton from '@material-ui/lab/Skeleton';
import { globalStyles } from 'GlobalStyles';
import FPIconButton from 'UI/components/atoms/FPIconButton';
import { SvgArrowLeft } from 'UI/res/icons/filled';

import { When } from '../When';

import { styles } from './styles';

/** @typedef {import('types/app').TitleLabelProps} TitleLabelProps */

/**
 * @param {TitleLabelProps} props
 */
const TitleLabel = ({
  titleAction,
  backNavigation = false,
  backNavigationProps,
  classes,
  gridLoadingProps,
  loading = false,
  mode = 'goBack',
  onCustomBackClick = () => {},
  subtitle = '',
  subtitleProps,
  text,
  variant = 'h2',
  ...rest
}) => {
  const history = useHistory();

  const handleGoBackButton = () => history.goBack();

  const clickType = mode === 'goBack' ? handleGoBackButton : onCustomBackClick;

  return (
    <>
      <When condition={loading}>
        <Grid container>
          <Grid item md={4} sm={6} {...gridLoadingProps}>
            <Skeleton style={globalStyles.skeletonItem} variant="rect" role="progressbar" />
          </Grid>
        </Grid>
      </When>
      <When condition={!loading}>
        <div className={classes.titleLabelGrid}>
          {backNavigation && (
            <div className={classes.iconButton}>
              <FPIconButton
                onClick={clickType}
                iconMode="custom"
                icon={SvgArrowLeft}
                tooltipProps={{ title: 'Back' }}
                {...backNavigationProps}
              />
            </div>
          )}
          <Typography variant={variant} className={classes.mainTitleContainer} {...rest}>
            {text}
            {titleAction && <div className={classes.actionButtonContainer}>{titleAction}</div>}
          </Typography>
          {subtitle && (
            <Typography component="div" {...subtitleProps} className={classes.subtitle}>
              {subtitle}
            </Typography>
          )}
        </div>
      </When>
    </>
  );
};

export default withStyles(styles)(TitleLabel);
